import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useApi } from 'services/api';
import useStore from 'services/store';
import { extractErrorMessage } from 'utils/api';
import { getConfiguredTimezone } from 'utils/datetime';

const selector = (state) => ({
  activeSensorsByProfile: state.searchQuery.activeSensorsByProfile,
});

const useSuggest = ({ query, searchType, context }) => {
  const api = useApi();
  const { activeSensorsByProfile } = useStore(selector);
  const timezone = getConfiguredTimezone();
  const isEnabled = !!query && !!searchType && activeSensorsByProfile !== undefined;
  const opts = useMemo(
    () => ({
      context: context || activeSensorsByProfile || [],
      searchType,
    }),
    [context, activeSensorsByProfile, searchType],
  );

  const { data, error, isLoading } = useQuery({
    queryKey: ['suggest', query, searchType, opts.context],
    queryFn: ({ signal }) =>
      api.get('/search/suggest', {
        params: { query, timezone, ...opts },
        signal,
      }),
    enabled: isEnabled,
  });

  const results = data && {
    timerange: data.compiled.daterange,
    input: data.compiled.input,
    t1: data.compiled.t1,
    t2: data.compiled.t2,
  };

  return { loading: isLoading, results, error: extractErrorMessage(error) };
};

export default useSuggest;
